import React from "react";
import { Form } from "react-final-form";
import { Box, Button, FormHelperText } from "@mui/material";

import { TextField } from "fond/form/fields";
import { required } from "fond/utils/validation";
import { Modal } from "fond/widgets";

interface ImageNameFormData {
  ImageName: string;
}

interface ImageNameDialogProps {
  defaultName?: string | null;
  onClose: () => void;
  onSubmit: (imageName: string) => void | Promise<void>;
  isSaving?: boolean;
}

const ImageNameDialog: React.FC<ImageNameDialogProps> = ({ defaultName, onClose, onSubmit, isSaving = false }) => {
  const handleFormSubmit = ({ ImageName }: ImageNameFormData) => {
    return onSubmit(ImageName.trim());
  };

  return (
    <Modal
      open
      onClose={onClose}
      header="Add overlay"
      variant="secondary"
      content={
        <Form<ImageNameFormData>
          initialValues={{ ImageName: defaultName ?? "" }}
          onSubmit={handleFormSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit} id="image-name-form">
              <Box maxWidth={380}>
                <TextField name="ImageName" required label="Name" autoFocus autoComplete="off" fullWidth validate={required} />
                <FormHelperText>Enter a name for the overlay.</FormHelperText>
              </Box>
            </form>
          )}
        />
      }
      actions={
        <>
          <Button color="primary" onClick={onClose} disabled={isSaving}>
            Cancel
          </Button>
          <Button color="primary" variant="contained" type="submit" form="image-name-form" disabled={isSaving}>
            {isSaving ? "Saving..." : "Create"}
          </Button>
        </>
      }
    />
  );
};

export default ImageNameDialog;
